var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bm-overlay',{ref:"customOverlay",class:{ sample: true, active: _vm.active },attrs:{"pane":"labelPane"},on:{"draw":_vm.draw}},[_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }